import * as React from "react";
import { logToAndylitics } from "../../api/andyliticsApi";
import { Link } from "react-router-dom";

export default class StartThrive extends React.Component {
    logActivity() {
        logToAndylitics('MBHWeb.Thrive.Start.Redirect', new Date(), this.props.thriveGetStartedUrl);
    }

    render() {
        const { thriveGetStartedUrl } = this.props;
        return (
            <div className="card submit-thrive">
                <div className="card-header">
                    <div className="row">
                        <div className="col-12">
                            <div className="card-heading">Baylor Scott & White employees, it’s that time again.</div>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-12">
                            <p>
                                Submit your Thrive health screening by <b>November 9</b> in order to avoid paying an additional $30 per pay period in 2019. 
                            </p>
                            <p>
                                To complete the Thrive Health Screening, you must be a Baylor Scott & White Employee. Spouses are optional and may submit only if desired.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="card-footer">
                    <div className="row">
                        <div className="col-12">
                            <Link className="btn btn-primary" to={{ pathname: "/thriveform" }} onClick={() => this.logActivity()}>
                                Get Started
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}